'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var assetsHelper = require('../../helper/assetsHelper');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var graphicsHelper = require('./../../helper/graphicsHelper.js');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/**
 * 浏览器组件
 * @author mxj
 */
var BrowserWindow = React.createClass({
  render: function () {
    var title;
    var url;
    var strArr;
    var text = styleHelper.getText(this.props);
    var showScrollBar = false;
    var value = 0;
    var style;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    if (text) {
      text = text.trim();
      if (text) {
        strArr = util.Text.delimitText(text,util.Text.DM_RETURN);
        if (strArr) {
          if (strArr.length > 0) {
            title = strArr[0];
          }
          if (strArr.length > 1) {
            url = strArr[1];
          }
        }
      }
    }
    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      showScrollBar = this.props.verticalScrollbarShow;
      value = util.Number.toInt(this.props.verticalScrollbarProgress);
    }
    style={
      height : '100%',
      width : '100%',
      left : 0,
      top : 0,
      overflow : 'hidden',
      backgroundColor : GlobalConst.GLOBAL_COLOR.SYSTEM_WHITE
    };
    styleHelper.builderTextStyle(this.props,style);
    return (
      <div className="component component-browserwindow" style={style}>
        <div className="bg" style={{
          height : h - 100,
          backgroundColor : this.props.color
        }}></div>
        <div className="img-bg">
          <canvas ref="canvas" width={w} height={h}>
            <img ref="img" src={assetsHelper.getComponentAsset('browserwindow')}
                 onLoad={this.onImageLoaded}/>
          </canvas>
        </div>
        <div className="title" style={{width:styleHelper.getWidth(this.props) - 4}}>
          <label>{title}</label>
        </div>
        <div className="url" style={{width:styleHelper.getWidth(this.props) - 188}}>
          <label>{url}</label>
        </div>
        {
          showScrollBar && (
            <VerticalScrollBar {...{top: 72, right: 1, height: h - 103, value: value, zIndex: 5}}/>)
        }
      </div>);
  },

  componentDidMount: function () {
    this.paint();
  },

  componentDidUpdate: function () {
    this.paint();
  },

  onImageLoaded: function () {
    this.isLoaded = true;
    this.paint();
  },

  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  paint: function () {
    if (this.isLoaded) {
      this.requestID = window.requestAnimationFrame(this.doPaint);
    }
  },

  doPaint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var graphics;
    var img = ReactDOM.findDOMNode(this.refs.img);
    var img9 = {
      left: 141,
      top: 74,
      right: 417,
      bottom: 374
    };
    if(canvas && img) {
      graphics = canvas.getContext('2d');

      graphicsHelper.drawNineGridImage(graphics, img, img9, {
        left: 0,
        top: 0,
        right: styleHelper.getWidth(this.props),
        bottom: styleHelper.getHeight(this.props)
      });
    }
  }

});

module.exports = BrowserWindow;



/** WEBPACK FOOTER **
 ** ./src/views/Components/BrowserWindow.jsx
 **/